import React from 'react';
import WebinarBanner from './components/WebinarBanner';
import WebinarData from './components/WebinarData/WebinarData';
import './Webinar.scss';
import { useFetchWebinarBannerQuery, useFetchWebinarPageQuery } from './Webinar.service';

const WebinarLanding = () => {
  const { data: webinarBanner } = useFetchWebinarBannerQuery();
  const { data: webinarPageData } = useFetchWebinarPageQuery();

  return webinarPageData && webinarBanner ? (
    <div className='webinarLanding'>
      <WebinarBanner bannerInfo={webinarBanner} webinarPage={webinarPageData} />
      <WebinarData webinarBanner={webinarBanner} webinarPageData={webinarPageData} />
    </div>
  ) : null;
};

export default WebinarLanding;
